
<script>
import Vue from "vue";

export default {
  name: "WaitEnd",
  props: {},
  methods: {
    send(startfn, endfn) {
      Vue.text = "送出後";
      Vue.nextTick(() => {
        endfn();
       // console.log("nextTick:fn");
      });
     

     // console.log("function run end:");
      startfn();
    },
  },
};
</script>

